<template>
  <div class="operation-report-show-body-form-item flex flex-col">
    <div class="form-item-label aisea-text-16-700-dark-gray">{{ label }}</div>
    <div class="form-item-value-unit flex aisea-text-16-400-dark-gray">
      <div class="form-item-value">{{ displayValue }}</div>
      <div class="form-item-unit flex items-center" v-show="hasUnit">
        {{ unit }}
      </div>
    </div>
    <!-- ラベルがある通常配置のときだけ注記を出す（テーブルセルでは出さない） -->
    <div v-if="hasLabel" class="form-item-unsupported-note">
      この項目はこの画面では編集できません
    </div>
  </div>
</template>

<script>
import isEmpty from "lodash/isEmpty";
import isString from "lodash/isString";

const FALLBACK_VALUE = "ー";

// 当画面で編集 UI を提供しない input_type（PORT_HIERARCHY_PICKER / CARGO_PICKER / BINDING /
export default {
  name: "FormItemUnsupported",
  inheritAttrs: false,
  props: {
    label: { type: String, default: "" },
    value: { type: [String, Number], default: "" },
    unit: { type: String, default: "" },
    isEditing: { type: Boolean, default: false },
    fallbackValue: { type: String, default: FALLBACK_VALUE },
  },
  computed: {
    hasLabel() {
      return isString(this.label) && !isEmpty(this.label);
    },
    displayValue() {
      const { value, fallbackValue } = this;
      if (value === "" || value === null || value === undefined) {
        return fallbackValue;
      }
      return value;
    },
    hasUnit() {
      return isString(this.unit) && !isEmpty(this.unit);
    },
  },
};
</script>
<style lang="scss" scoped>
.operation-report-show-body-form-item {
  min-height: 90px;
  padding: 18px 0;
  row-gap: 4px;

  .form-item-unsupported-note {
    font-size: 12px;
    color: #888;
    margin-top: 2px;
  }
}
</style>
